import { render, staticRenderFns } from "./detail-index.vue?vue&type=template&id=2f51b83e&scoped=true&"
import script from "./detail-index.vue?vue&type=script&lang=js&"
export * from "./detail-index.vue?vue&type=script&lang=js&"
import style0 from "./detail-index.vue?vue&type=style&index=0&id=2f51b83e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f51b83e",
  null
  
)

export default component.exports